module.exports = __webpack_public_path__ + "static/media/logo2_web.d73ad439.png";